import { mapValues } from 'lodash'

import { TMapTile } from './types'

type TGetMapTilesOpts = {
  lowres?: boolean
}

export const TILE_URL = 'https://maptiles-v2.1st-scan.com'

export const HERE_API_KEY = 'Y-yCZuJZDpPd58xSXcpCoEkedXCBKZdFyCFLIeLdBJk'

function getMapTileSettings({
  lowres,
}: {
  lowres: boolean
}): Record<string, any> {
  const isHiDPI = window.devicePixelRatio > 1
  const suffix = isHiDPI && !lowres ? '@2x' : ''
  const tileSize = lowres ? 128 : isHiDPI ? 512 : 256
  const hereTileSize = lowres ? 256 : isHiDPI ? 512 : 512
  return {
    suffix,
    tileSize,
    hereTileSize,
  }
}

export function getMapTiles(
  { lowres = false }: TGetMapTilesOpts = { lowres: false },
): Record<string, TMapTile> {
  const { suffix, tileSize, hereTileSize } = getMapTileSettings({ lowres })
  return mapValues(
    {
      standard: {
        label: i18n.t(`default_map_layer`, `Standard`),
        url: `${TILE_URL}/styles/positron/{z}/{x}/{y}${suffix}.png`,
        tileSize,
        vectorStyle: 'positron',
      },
      street: {
        label: i18n.t(`street_map_layer`, `Strasse`),
        url: `${TILE_URL}/styles/bright/{z}/{x}/{y}${suffix}.png`,
        tileSize,
        vectorStyle: 'streets',
      },
      streetalternate: {
        label: i18n.t(`street_map_layer_alternate`, `Strasse (OSM)`),
        url: `${TILE_URL}/styles/openstreetmap/{z}/{x}/{y}${suffix}.png`,
        tileSize,
        vectorStyle: 'openstreetmap',
      },
      basic: {
        label: i18n.t(`basic_layer_label`, `Basis`),
        url: `${TILE_URL}/styles/basic/{z}/{x}/{y}${suffix}.png`,
        tileSize,
        vectorStyle: 'basic',
      },
      dark: {
        label: i18n.t(`darkened_map_layer`, `Abgedunkelt`),
        url: `${TILE_URL}/styles/dark-matter/{z}/{x}/{y}${suffix}.png`,
        tileSize,
        vectorStyle: 'dark-matter',
      },
      // surrounding: {
      //   label: i18n.t(`env_map_layer`, `Umgebung`),
      //   url: `${TILE_URL}/styles/terrain/{z}/{x}/{y}${suffix}.png`,
      //   tileSize,
      // },
      pastel: {
        label: i18n.t(`pastel_map_layer`, `Pastell`),
        url: `${TILE_URL}/styles/pastel/{z}/{x}/{y}${suffix}.png`,
        tileSize,
        vectorStyle: 'pastel',
      },
      voyager: {
        label: i18n.t(`voyager_map_layer`, `Voyager`),
        url: `${TILE_URL}/styles/voyager/{z}/{x}/{y}${suffix}.png`,
        tileSize,
        vectorStyle: 'voyager',
      },
      // topo: {
      //   label: i18n.t(`topo_map_layer`, `Tophographisch`),
      //   url: `${TILE_URL}/styles/topo/{z}/{x}/{y}${suffix}.png`,
      //   tileSize,
      // },
      trafficDay: {
        label: i18n.t(`here_day_map_layer`, `HERE (Tag)`),
        url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?size=${hereTileSize}&style=explore.day&ppi=400&apiKey=${HERE_API_KEY}`,
        tileSize: 256,
      },
      trafficNight: {
        label: i18n.t(`here_night_map_layer`, `HERE (Nacht)`),
        url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?size=${hereTileSize}&style=explore.night&ppi=400&apiKey=${HERE_API_KEY}`,
        tileSize: 256,
      },
      trafficSatellite: {
        label: i18n.t(`here_satellite_map_layer`, `HERE (Satellit)`),
        url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?size=${hereTileSize}&style=explore.satellite.day&ppi=400&apiKey=${HERE_API_KEY}`,
        tileSize: 256,
      },
    },
    (value, key) => ({ ...value, name: key }),
  )
}

export function getTrafficLayerUrl(): string {
  const { suffix, tileSize, hereTileSize } = getMapTileSettings({
    lowres: false,
  })
  return `https://traffic.maps.hereapi.com/v3/flow/mc/{z}/{x}/{y}/png?apiKey=${HERE_API_KEY}`
}
